import { Button } from "../../components/ui/Button";
import CarouselFGTS from "../../components/ui/CarouselFGTS";

export const HowAnticipate = ({onGoToRegister}) => (
    <section id="HowAnticipateFgts" className="bg-[#F4F5F6] py-16 px-6 mx-auto">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-12">

            <div className="w-full lg:w-1/2">
                <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                    Solicitação 100% online
                </span>

                <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 leading-relaxed mb-4">
                    Como antecipar meu Saque-Aniversário no Bmg?
                </h2>

                <p className="text-gray-600 mb-8 leading-relaxed">
                    É só baixar o app FGTS em seu dispositivo móvel. Entre no aplicativo para fazer o login ou criar uma conta caso ainda não tenha.
                </p>

                <h3 className="text-base font-bold text-gray-800 mb-4">
                    É rápido, fácil e sem burocracia:
                </h3>

                <ul className="space-y-6 mb-8">
                    <li className="flex items-center gap-4">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">1</div>
                        <span className="text-[#37404E] font-bold">Optar pelo Saque-Aniversário.</span>
                    </li>
                    <li className="flex items-center gap-4">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">2</div>
                        <span className="text-[#37404E] font-bold">Autorizar o banco a consultar seus dados e valores do FGTS.</span>
                    </li>
                    <li className="flex items-center gap-4">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">3</div>
                        <span className="text-[#37404E] font-bold">Simular e se estiver de acordo, aguardar aprovação.</span>
                    </li>
                    <li className="flex items-center gap-4">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">4</div>
                        <span className="text-[#37404E] font-bold">Dinheiro na conta para usar como quiser.</span>
                    </li>
                </ul>

                <Button onClick={onGoToRegister}>
                    Simular antecipação <span className="font-semibold">FGTS</span>
                </Button>
            </div>

            <div className="w-full lg:w-1/2 flex justify-center items-center">
                <CarouselFGTS />
            </div>
        </div>
    </section>
)